"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MarketplaceCXIdMappingClientImpl = /** @class */ (function () {
    function MarketplaceCXIdMappingClientImpl(configSet) {
        this.configSet = configSet;
    }
    MarketplaceCXIdMappingClientImpl.prototype.getCxFamily = function (context, weblabContext) {
        return this.configSet.getString("cx_family", context === null || context === void 0 ? void 0 : context.toRawContext(), weblabContext);
    };
    MarketplaceCXIdMappingClientImpl.prototype.getCxId = function (context, weblabContext) {
        return this.configSet.getString("cx_id", context === null || context === void 0 ? void 0 : context.toRawContext(), weblabContext);
    };
    return MarketplaceCXIdMappingClientImpl;
}());
exports.default = MarketplaceCXIdMappingClientImpl;
